export const countryMarkers = [
    { country: "Afghanistan", coordinates: [67.709953, 33.93911] },
    { country: "Albania", coordinates: [20.168331, 41.153332] },
    { country: "Algeria", coordinates: [1.659626, 28.033886] },
    { country: "Andorra", coordinates: [1.601554, 42.546245] },
    { country: "Angola", coordinates: [17.873887, -11.202692] },
    { country: "Argentina", coordinates: [-63.616672, -38.416097] },
    { country: "Armenia", coordinates: [45.038189, 40.069099] },
    { country: "Australia", coordinates: [133.775136, -25.274398] },
    { country: "Austria", coordinates: [14.550072, 47.516231] },
    { country: "Azerbaijan", coordinates: [47.576927, 40.143105] },
    { country: "Bahamas", coordinates: [-77.396279, 25.03428] },
    { country: "Bahrain", coordinates: [50.5577, 26.0667] },
    { country: "Bangladesh", coordinates: [90.356331, 23.684994] },
    { country: "Barbados", coordinates: [-59.543198, 13.193887] },
    { country: "Belarus", coordinates: [27.953389, 53.709807] },
    { country: "Belgium", coordinates: [4.469936, 50.503887] },
    { country: "Belize", coordinates: [-88.49765, 17.189877] },
    { country: "Benin", coordinates: [2.315834, 9.30769] },
    { country: "Bhutan", coordinates: [90.433601, 27.514162] },
    { country: "Bolivia", coordinates: [-63.588653, -16.290154] },
    { country: "Bosnia and Herzegovina", coordinates: [17.679076, 43.915886] },
    { country: "Botswana", coordinates: [24.684866, -22.328474] },
    { country: "Brazil", coordinates: [-51.92528, -14.235004] },
    { country: "Brunei", coordinates: [114.727669, 4.535277] },
    { country: "Bulgaria", coordinates: [25.48583, 42.733883] },
    { country: "Burkina Faso", coordinates: [-1.561593, 12.238333] },
    { country: "Burundi", coordinates: [29.918886, -3.373056] },
    { country: "Cabo Verde", coordinates: [-23.605172, 16.002082] },
    { country: "Cambodia", coordinates: [104.990963, 12.565679] },
    { country: "Cameroon", coordinates: [12.354722, 7.369722] },
    { country: "Canada", coordinates: [-106.346771, 56.130366] },
    { country: "Central African Republic", coordinates: [20.939444, 6.611111] },
    { country: "Chad", coordinates: [18.732207, 15.454166] },
    { country: "Chile", coordinates: [-71.542969, -35.675147] },
    { country: "China", coordinates: [104.195397, 35.86166] },
    { country: "Colombia", coordinates: [-74.297333, 4.570868] },
    { country: "Comoros", coordinates: [43.872219, -11.875001] },
    { country: "Congo (Congo-Brazzaville)", coordinates: [15.827659, -0.228021] },
    { country: "Costa Rica", coordinates: [-83.753428, 9.748917] },
    { country: "Croatia", coordinates: [15.2, 45.1] },
    { country: "Cuba", coordinates: [-77.781167, 21.521757] },
    { country: "Cyprus", coordinates: [33.429859, 35.126413] },
    { country: "Czechia (Czech Republic)", coordinates: [15.472962, 49.817492] },
    { country: "Denmark", coordinates: [9.501785, 56.26392] },
    { country: "Djibouti", coordinates: [42.590275, 11.825138] },
    { country: "Dominica", coordinates: [-61.370976, 15.414999] },
    { country: "Dominican Republic", coordinates: [-70.162651, 18.735693] },
    { country: "Ecuador", coordinates: [-78.183406, -1.831239] },
    { country: "Egypt", coordinates: [30.802498, 26.820553] },
    { country: "El Salvador", coordinates: [-88.89653, 13.794185] },
    { country: "Equatorial Guinea", coordinates: [10.267895, 1.650801] },
    { country: "Eritrea", coordinates: [39.782334, 15.179384] },
    { country: "Estonia", coordinates: [25.013607, 58.595272] },
    { country: "Eswatini", coordinates: [31.465866, -26.522503] },
    { country: "Ethiopia", coordinates: [39.782334, 9.145] },
    { country: "Fiji", coordinates: [179.414413, -16.578193] },
    { country: "Finland", coordinates: [25.748151, 61.92411] },
    { country: "France", coordinates: [2.213749, 46.603354] },
    { country: "Gabon", coordinates: [11.609444, -0.803689] },
    { country: "Gambia", coordinates: [-15.310139, 13.443182] },
    { country: "Georgia", coordinates: [43.356892, 42.315407] },
    { country: "Germany", coordinates: [10.451526, 51.165691] },
    { country: "Ghana", coordinates: [-1.023194, 7.946527] },
    { country: "Greece", coordinates: [21.824312, 39.074208] },
    { country: "Grenada", coordinates: [-61.679, 12.1165] },
    { country: "Guatemala", coordinates: [-90.230759, 15.783471] },
    { country: "Guinea", coordinates: [-9.696645, 9.945587] },
    { country: "Guinea-Bissau", coordinates: [-15.180413, 11.803749] },
    { country: "Guyana", coordinates: [-58.93018, 4.860416] },
    { country: "Haiti", coordinates: [-72.285215, 18.971187] },
    { country: "Honduras", coordinates: [-86.241905, 15.199999] },
    { country: "Hungary", coordinates: [19.503304, 47.162494] },
    { country: "Iceland", coordinates: [-19.020835, 64.963051] },
    { country: "India", coordinates: [78.96288, 20.593684] },
    { country: "Indonesia", coordinates: [113.921327, -0.789275] },
    { country: "Iran", coordinates: [53.688046, 32.427908] },
    { country: "Iraq", coordinates: [43.679291, 33.223191] },
    { country: "Ireland", coordinates: [-8.24389, 53.41291] },
    { country: "Israel", coordinates: [34.851612, 31.046051] },
    { country: "Italy", coordinates: [12.56738, 41.87194] },
    { country: "Jamaica", coordinates: [-77.297508, 18.109581] },
    { country: "Japan", coordinates: [138.252924, 36.204824] },
    { country: "Jordan", coordinates: [36.238414, 30.585164] },
    { country: "Kazakhstan", coordinates: [66.923684, 48.019573] },
    { country: "Kenya", coordinates: [37.906193, -1.292066] },
    { country: "Kiribati", coordinates: [-168.734039, -3.370417] },
    { country: "Kuwait", coordinates: [47.481766, 29.31166] },
    { country: "Kyrgyzstan", coordinates: [74.766098, 41.20438] },
    { country: "Laos", coordinates: [102.495496, 19.85627] },
    { country: "Latvia", coordinates: [24.603189, 56.879635] },
    { country: "Lebanon", coordinates: [35.862285, 33.854721] },
    { country: "Lesotho", coordinates: [28.233608, -29.609988] },
    { country: "Liberia", coordinates: [-9.429499, 6.428055] },
    { country: "Libya", coordinates: [17.228331, 26.3351] },
    { country: "Liechtenstein", coordinates: [9.555373, 47.166] },
    { country: "Lithuania", coordinates: [23.881275, 55.169438] },
    { country: "Luxembourg", coordinates: [6.129583, 49.815273] },
    { country: "Madagascar", coordinates: [46.869107, -18.766947] },
    { country: "Malawi", coordinates: [34.301525, -13.254308] },
    { country: "Malaysia", coordinates: [101.975766, 4.210484] },
    { country: "Maldives", coordinates: [73.22068, 3.202778] },
    { country: "Mali", coordinates: [-3.996166, 17.570692] },
    { country: "Malta", coordinates: [14.375416, 35.937496] },
    { country: "Marshall Islands", coordinates: [171.184478, 7.131474] },
    { country: "Mauritania", coordinates: [-10.940835, 21.00789] },
    { country: "Mauritius", coordinates: [57.552152, -20.348404] },
    { country: "Mexico", coordinates: [-102.552784, 23.634501] },
    { country: "Micronesia", coordinates: [150.550812, 7.425554] },
    { country: "Moldova", coordinates: [28.369885, 47.411631] },
    { country: "Monaco", coordinates: [7.412841, 43.750298] },
    { country: "Mongolia", coordinates: [103.846656, 46.862496] },
    { country: "Montenegro", coordinates: [19.37439, 42.708678] },
    { country: "Morocco", coordinates: [-7.09262, 31.791702] },
    { country: "Mozambique", coordinates: [35.529562, -18.665695] },
    { country: "Myanmar (formerly Burma)", coordinates: [95.956223, 21.913965] },
    { country: "Namibia", coordinates: [18.49041, -22.95764] },
    { country: "Nauru", coordinates: [166.931503, -0.522778] },
    { country: "Nepal", coordinates: [84.124008, 28.394857] },
    { country: "Netherlands", coordinates: [5.291266, 52.132633] },
    { country: "New Zealand", coordinates: [174.885971, -40.900557] },
    { country: "Nicaragua", coordinates: [-85.207229, 12.865416] },
    { country: "Niger", coordinates: [8.081666, 17.607789] },
    { country: "Nigeria", coordinates: [8.675277, 9.081999] },
    { country: "North Korea", coordinates: [127.510093, 40.339852] },
    { country: "North Macedonia", coordinates: [21.745275, 41.608635] },
    { country: "Norway", coordinates: [8.468946, 60.472024] },
    { country: "Oman", coordinates: [55.923255, 21.512583] },
    { country: "Pakistan", coordinates: [69.345116, 30.375321] },
    { country: "Palau", coordinates: [134.58252, 7.51498] },
    { country: "Palestine State", coordinates: [35.233154, 31.952162] },
    { country: "Panama", coordinates: [-80.782127, 8.537981] },
    { country: "Papua New Guinea", coordinates: [143.95555, -6.314993] },
    { country: "Paraguay", coordinates: [-58.443832, -23.442503] },
    { country: "Peru", coordinates: [-75.015152, -9.189967] },
    { country: "Philippines", coordinates: [121.774017, 12.879721] },
    { country: "Poland", coordinates: [19.145136, 51.919438] },
    { country: "Portugal", coordinates: [-8.224454, 39.399872] },
    { country: "Qatar", coordinates: [51.183884, 25.354826] },
    { country: "Romania", coordinates: [24.96676, 45.943161] },
    { country: "Russia", coordinates: [105.318756, 61.52401] },
    { country: "Rwanda", coordinates: [29.873888, -1.940278] },
    { country: "Saint Kitts and Nevis", coordinates: [-62.782998, 17.357822] },
    { country: "Saint Lucia", coordinates: [-60.978893, 13.909444] },
    { country: "Saint Vincent and the Grenadines", coordinates: [-61.287228, 12.984305] },
    { country: "Samoa", coordinates: [-172.104629, -13.759029] },
    { country: "San Marino", coordinates: [12.457777, 43.94236] },
    { country: "Sao Tome and Principe", coordinates: [6.613081, 0.18636] },
    { country: "Saudi Arabia", coordinates: [45.079162, 23.885942] },
    { country: "Senegal", coordinates: [-14.452362, 14.497401] },
    { country: "Serbia", coordinates: [21.005859, 44.016521] },
    { country: "Seychelles", coordinates: [55.491977, -4.679574] },
    { country: "Sierra Leone", coordinates: [-11.779889, 8.460555] },
    { country: "Singapore", coordinates: [103.819836, 1.352083] },
    { country: "Slovakia", coordinates: [19.699024, 48.669026] },
    { country: "Slovenia", coordinates: [14.995463, 46.151241] },
    { country: "Solomon Islands", coordinates: [160.156194, -9.64571] },
    { country: "Somalia", coordinates: [46.199616, 5.152149] },
    { country: "South Africa", coordinates: [22.937506, -30.559482] },
    { country: "Republic of Korea", coordinates: [127.766922, 35.907757] },
    { country: "South Sudan", coordinates: [30.217636, 7.862684] },
    { country: "Spain", coordinates: [-3.74922, 40.463667] },
    { country: "Sri Lanka", coordinates: [80.771797, 7.873054] },
    { country: "Sudan", coordinates: [30.217636, 12.862807] },
    { country: "Suriname", coordinates: [-56.027783, 3.919305] },
    { country: "Sweden", coordinates: [18.643501, 60.128161] },
    { country: "Switzerland", coordinates: [8.227512, 46.818188] },
    { country: "Syria", coordinates: [38.996815, 34.802075] },
    { country: "Taiwan", coordinates: [121.565418, 23.69781] },
    { country: "Tajikistan", coordinates: [71.276093, 38.861034] },
    { country: "Tanzania", coordinates: [34.888822, -6.369028] },
    { country: "Thailand", coordinates: [100.992541, 15.870032] },
    { country: "Timor-Leste", coordinates: [125.727539, -8.874217] },
    { country: "Togo", coordinates: [0.824782, 8.619543] },
    { country: "Tonga", coordinates: [-175.198242, -21.178986] },
    { country: "Trinidad and Tobago", coordinates: [-61.222503, 10.691803] },
    { country: "Tunisia", coordinates: [9.537499, 33.886917] },
    { country: "Turkey", coordinates: [35.243322, 38.963745] },
    { country: "Turkmenistan", coordinates: [59.556278, 38.969719] },
    { country: "Tuvalu", coordinates: [179.194792, -7.109535] },
    { country: "Uganda", coordinates: [32.290275, 1.373333] },
    { country: "Ukraine", coordinates: [31.16558, 48.379433] },
    { country: "United Arab Emirates", coordinates: [53.847818, 23.424076] },
    { country: "United Kingdom", coordinates: [-3.435973, 55.378051] },
    { country: "United States", coordinates: [-95.712891, 37.09024] },
    { country: "Uruguay", coordinates: [-55.765835, -32.522779] },
    { country: "Uzbekistan", coordinates: [64.585262, 41.377491] },
    { country: "Vanuatu", coordinates: [166.959158, -15.376706] },
    { country: "Vatican City", coordinates: [12.453389, 41.902916] },
    { country: "Venezuela", coordinates: [-66.58973, 6.42375] },
    { country: "Vietnam", coordinates: [108.277199, 14.058324] },
    { country: "Yemen", coordinates: [48.516388, 15.552727] },
    { country: "Zambia", coordinates: [27.849332, -13.133897] },
    { country: "Zimbabwe", coordinates: [29.154857, -19.015438] }
  ];
  